export default class ProjectDirectivePersist {
  id?: string;

  activated: boolean;

  inheritance: boolean;

  constructor(obj: any = {}) {
    if (obj.id) this.id = obj.id;
    this.activated = obj.activated;
    this.inheritance = obj.inheritance;
  }
}
